import React from "react";
import { Table } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

const styleCard ={
    borderRadius: '1rem'
}

const financialData = {
    "columns": ["Aug 2024", "Sep 2024", "Oct 2024","Nov 2024"],
    "data": [
      { "rowLabel": "Email sent", "values": [214, 241, 257, 322] },
      { "rowLabel": "Follow-ups", "values": [130, 148, 154, 200] },
      { "rowLabel": "Leads", "values": [84, 93, 103, 122] },
      // { "rowLabel": "Leads", "values": [21, 29, 30, 37] },
      { "rowLabel": "Trails", "values": ["61%", "61%", "60%", "62%"] },
      { "rowLabel": "Not-intrested", "values": [145, 168, 175, 225] },
    //   { "rowLabel": "Tax %", "values": ["26%", "23%", "23%", "28%"] },
    //   { "rowLabel": "Net Profit", "values": [107, 129, 134, 162] },
    //   { "rowLabel": "EPS in Rs", "values": [5.14, 6.18, 6.42, 7.75] }
    ]
};  

const FinancialTable = () => {
  return (
    <Card style={styleCard}>
    <CardBody>
    <div className="container mt-4">
      <h4>Monthly Results</h4>
      <Table bordered hover responsive>
        <thead>
          <tr>
            <th> </th>
            {financialData.columns.map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {financialData.data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td><strong>{row.rowLabel}</strong></td>
              {row.values.map((value, colIndex) => (
                <td key={colIndex}>{value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
    </CardBody>
    </Card>
  );
};

export default FinancialTable;
